import { ErrorFallback, type WidgetErrorProps } from '@/shared/ui/ErrorBoundary';

import { usePodOverview } from '@/features/monitoring';

import { PodOverviewTable } from '@/widgets/monitoring/PodOverviewTable';

import styles from './PodOverviewMetric.module.css';

const Content = () => {
  const { data: podOverviewData, isLoading: podOverviewLoading } = usePodOverview();

  return <PodOverviewTable data={podOverviewData} isLoading={podOverviewLoading} />;
};

const Error = ({ title, description, ...props }: WidgetErrorProps) => {
  return <ErrorFallback title={title} description={description} className={styles.error} {...props} />;
};

export const PodOverviewMetric = { Content, Error };
